import { Feedback } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'

// The status region (<output>) stays mounted so screen readers announce the warning when it appears inside it.
export const CaptchaSlowWarning = ({ isSlow }: { isSlow: boolean }) => {
  const { t } = useTranslation()

  return <output>{isSlow && <Feedback variant="warning">{t('errorMessage.captchaSlow')}</Feedback>}</output>
}
